import { Moment } from 'moment';
import { RelateveDate } from './relative-date';
import { SearchAction } from './search-action';
import { SearchColumn } from './search-column';
import { SearchDataType } from './search-data-type';
import { SearchOperator } from './search-operator';
import { SystemUser } from './system-user';

export class SearchRule {

    constructor(
         public searchAction: SearchAction,
         public searchOperator: SearchOperator,
         public searchColumn: SearchColumn,
         public valueType: SearchDataType,
         public strValue?: string | null,
         public longValue?: number | null,
         public dateValue?: Moment | null,
         public booleanValue?: boolean | null,
         public relativeDate?: RelateveDate,
         public created?: Moment,
         public createdBy?: SystemUser,
         public id?: number
    ){}
}
